export const SET_GLOBAL_SEARCH = 'SET_GLOBAL_SEARCH';
export const CLEAR_GLOBAL_SEARCH = 'CLEAR_GLOBAL_SEARCH';
